const StaffTurnover = () => import('./views/StaffTurnover.vue')
export default [
    {
        path: '/project/:id/GCB2/staffTurnover',
        name: 'GCB2StaffTurnover',
        component: StaffTurnover,
    },
]